<div class="field-groups">
  @for (group of fieldGroups(); track group.key) {
    <details class="field-group" [attr.open]="isCoreFilterGroup(group.key) ? '' : null">
      <summary class="group-summary">
        <span class="group-title">{{ group.label }}</span>
        @if (!isCoreFilterGroup(group.key)) {
          <span class="group-toggle" aria-hidden="true">+</span>
        }
      </summary>

      <div class="field-grid">
        @for (field of group.fields; track field.name) {
          <div class="field" [class.field--full]="field.type === 'text'">
            <div class="field-header">
              <label class="field-label" [attr.for]="fieldId(field.name)">
                {{ field.label }}@if (field.required) { * }
              </label>
              @if (fieldHasValue(field)) {
                <button
                  type="button"
                  class="field-clear"
                  [disabled]="disabled()"
                  [attr.aria-label]="'Clear ' + field.label"
                  (click)="clearField(field)"
                >
                  Clear
                </button>
              }
            </div>

            @if (field.helpText) {
              <p class="field-help" [attr.id]="helpId(field.name)">{{ field.helpText }}</p>
            }

            @switch (field.type) {
              @case ('text') {
                <input
                  [id]="fieldId(field.name)"
                  class="field-control"
                  [class.field-control--active]="fieldHasValue(field)"
                  type="text"
                  [value]="getInputValue(field)"
                  [disabled]="disabled()"
                  [placeholder]="field.placeholder ?? ''"
                  [attr.aria-describedby]="field.helpText ? helpId(field.name) : null"
                  (input)="onInput(field, $event)"
                />
              }
              @case ('number') {
                <input
                  [id]="fieldId(field.name)"
                  class="field-control"
                  [class.field-control--active]="fieldHasValue(field)"
                  type="number"
                  [value]="getInputValue(field)"
                  [disabled]="disabled()"
                  [placeholder]="field.placeholder ?? ''"
                  [attr.aria-describedby]="field.helpText ? helpId(field.name) : null"
                  (input)="onInput(field, $event)"
                />
              }
              @case ('date') {
                <input
                  [id]="fieldId(field.name)"
                  class="field-control"
                  [class.field-control--active]="fieldHasValue(field)"
                  type="date"
                  [value]="getInputValue(field)"
                  [disabled]="disabled()"
                  [attr.aria-describedby]="field.helpText ? helpId(field.name) : null"
                  (change)="onInput(field, $event)"
                />
              }
              @case ('boolean') {
                <select
                  [id]="fieldId(field.name)"
                  class="field-control"
                  [class.field-control--active]="fieldHasValue(field)"
                  [disabled]="disabled()"
                  [attr.aria-describedby]="field.helpText ? helpId(field.name) : null"
                  [value]="booleanSelectValue(field)"
                  (change)="onBooleanChange(field, $event)"
                >
                  <option value="">Any</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              }
              @case ('select') {
                <select
                  [id]="fieldId(field.name)"
                  class="field-control"
                  [class.field-control--active]="fieldHasValue(field)"
                  [disabled]="disabled()"
                  [attr.aria-describedby]="field.helpText ? helpId(field.name) : null"
                  [value]="getInputValue(field)"
                  (focus)="loadOptionsOnFocus(field)"
                  (change)="onSelectChange(field, $event)"
                >
                  <option value="">Any</option>
                  @for (option of getOptions(field); track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
              }
              @case ('multiselect') {
                <div
                  class="field-option-list"
                  role="group"
                  [attr.aria-label]="field.label"
                  [attr.aria-describedby]="field.helpText ? helpId(field.name) : null"
                  (focusin)="loadOptionsOnFocus(field)"
                >
                  @if (optionLoadingMap()[field.name]) {
                    <span class="field-option-empty">Loading options…</span>
                  } @else if (getOptions(field).length === 0) {
                    <span class="field-option-empty">No options loaded yet.</span>
                  } @else {
                    @for (option of getOptions(field); track option.value) {
                      <button
                        type="button"
                        class="field-option"
                        [class.field-option--selected]="isMultiOptionSelected(field, option.value)"
                        [attr.aria-pressed]="isMultiOptionSelected(field, option.value)"
                        [disabled]="disabled()"
                        (click)="toggleMultiOption(field, option.value)"
                      >
                        <span class="field-option-label">{{ option.label }}</span>
                      </button>
                    }
                  }
                </div>
              }
            }

            @if (optionLoadingMap()[field.name] && field.type !== 'multiselect') {
              <span class="field-loading">Loading options…</span>
            }

            @if (optionErrorMap()[field.name]) {
              <button
                type="button"
                class="field-clear retry-options"
                [disabled]="disabled()"
                (click)="retryFieldOptions.emit(field)"
              >
                Retry loading options
              </button>
            }
          </div>
        }
      </div>
    </details>
  }
</div>
